/* Country Road Fashions — endless scroll for the grids (crf-collection.liquid,
   crf-search.liquid).

   Shiva, 2026-09-25: a customer scrolling a collection or a search never
   meets "1 2 3 Next page". The next page is fetched through the Section
   Rendering API (`?page=N&sections=<id>`, the call crf-bag.js also makes)
   and its tiles are moved into the grid already on the page. When the last
   page has arrived, the "More to explore" band (crf-explore.liquid) is shown.

   Shopify's own pagination stays underneath: with scripts off the numbered
   pager renders and `?page=2` works, and if a fetch fails the pager comes
   back so the customer is never stranded. The URL is never rewritten -- a
   reload at ?page=3 would open on page 3's tiles with nothing above them. */
(function () {
  'use strict';

  document.querySelectorAll('.crf-coll[data-crf-scroll]').forEach(function (root) {
    if (root.dataset.crfScrollReady) return;
    root.dataset.crfScrollReady = '1';

    var id = root.dataset.sectionId;
    var main = root.querySelector('.crf-coll__main');
    var explore = document.querySelector('[data-crf-explore]');
    if (!id || !main) { if (explore) explore.hidden = false; return; }

    var pager = main.querySelector('.crf-pager');
    var next = pager && pager.querySelector('a[rel="next"]');
    var nextUrl = next ? next.getAttribute('href') : null;

    // One page, or nothing at all: nothing to load, the band shows at once.
    if (!nextUrl || !('IntersectionObserver' in window)) {
      if (explore) explore.hidden = false;
      return;
    }
    if (explore) explore.hidden = true;

    root.classList.add('is-endless');

    var status = document.createElement('p');
    status.className = 'crf-scroll__status crf-caption';
    status.setAttribute('aria-live', 'polite');
    var end = document.createElement('div');
    end.className = 'crf-scroll__end';
    main.appendChild(status);
    main.appendChild(end);

    var busy = false;

    function lastGrid(scope) {
      var grids = scope.querySelectorAll('.crf-grid');
      return grids.length ? grids[grids.length - 1] : null;
    }

    function insertBefore(el) { main.insertBefore(el, status); }

    function move(fromList, toList) {
      Array.prototype.slice.call(fromList.children).forEach(function (li) { toList.appendChild(li); });
    }

    // Chaptered collections render a .crf-chapter head before each grid;
    // a chapter that continues over the page break is merged, one that is
    // new is appended, counts added up.
    function merge(doc) {
      var incoming = doc.querySelector('.crf-coll__main') || doc.body;
      var chapters = incoming.querySelectorAll('.crf-chapter');
      if (chapters.length) {
        chapters.forEach(function (head) {
          var grid = head.nextElementSibling;
          if (!grid || !grid.classList.contains('crf-grid')) return;
          var name = (head.querySelector('h2') || {}).textContent || '';
          var have = null;
          main.querySelectorAll('.crf-chapter').forEach(function (h) {
            var t = (h.querySelector('h2') || {}).textContent || '';
            if (t.trim() === name.trim()) have = h;
          });
          if (have && have.nextElementSibling && have.nextElementSibling.classList.contains('crf-grid')) {
            move(grid, have.nextElementSibling);
            var a = have.querySelector('span.crf-caption'), b = head.querySelector('span.crf-caption');
            if (a && b) a.textContent = String((parseInt(a.textContent, 10) || 0) + (parseInt(b.textContent, 10) || 0));
          } else {
            insertBefore(head);
            insertBefore(grid);
          }
        });
      } else {
        var grid = incoming.querySelector('.crf-grid');
        var target = lastGrid(main);
        if (grid && target) move(grid, target);
        else if (grid) insertBefore(grid);
      }
      // The search page lists pages and articles under the products.
      var pages = incoming.querySelector('.crf-search__pages');
      var havePages = main.querySelector('.crf-search__pages');
      if (pages && havePages) move(pages, havePages);
      else if (pages) insertBefore(pages);

      var p = incoming.querySelector('.crf-pager');
      var n = p && p.querySelector('a[rel="next"]');
      return n ? n.getAttribute('href') : null;
    }

    function finish() {
      observer.disconnect();
      end.remove();
      status.remove();
      if (explore) explore.hidden = false;
    }

    function fallback() {
      observer.disconnect();
      root.classList.remove('is-endless');
      status.textContent = '';
      end.remove();
      if (explore) explore.hidden = false;
    }

    function load() {
      if (busy || !nextUrl) return;
      busy = true;
      status.textContent = root.dataset.loading || '';
      var url = nextUrl + (nextUrl.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(id);
      // No Accept: application/json here: Shopify reads that as a request for
      // the collection's .json endpoint and answers 404 (seen 2026-09-25).
      fetch(url)
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (json) {
          var html = json[id];
          if (!html) return Promise.reject(new Error('no section'));
          var doc = new DOMParser().parseFromString(html, 'text/html');
          nextUrl = merge(doc);
          status.textContent = '';
          busy = false;
          if (!nextUrl) finish();
          else observer.observe(end);
        })
        .catch(function () { busy = false; fallback(); });
    }

    var observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        observer.unobserve(end);
        load();
      }
    }, { rootMargin: '0px 0px 900px 0px' });
    observer.observe(end);
  });
})();
